import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { authSlice } from './common/authSlice';
import { loadingSlice } from './common/loadingSlice';
import { apiValidationErrorSlice } from './common/apiValidationErrorSlice';
import { cardSagaReducers } from './cardSagaReducers';
import { heroSagaReducers } from './heroSagaReducers';
import { itemSagaReducers } from './itemSagaReducers';
import { shopSagaReducers } from './shopSagaReducers';
import { eventSagaReducers } from './eventSagaReducers';
import { dashboardReducers } from './dashboardReducers';
import { userReducers } from './userReducers';

const appReducers = combineReducers({
    auth: authSlice.reducer,
    loading: loadingSlice.reducer,
    apiValidationError: apiValidationErrorSlice.reducer,
    dashboard: dashboardReducers,
    user: userReducers,
    cardSaga: cardSagaReducers,
    heroSaga: heroSagaReducers,
    itemSaga: itemSagaReducers,
    shopSaga: shopSagaReducers,
    eventSaga: eventSagaReducers,
});

const rootReducer = (state, action) => {
    if (action.type === 'auth/logout') {
        state = undefined;
    }
    return appReducers(state, action);
};

export default configureStore({
    reducer: rootReducer,
});
